<template>
  <div>
    <SettingGroup title="電池残量表示">
      <SettingItem label="LCD">
        <ToggleSwitch
          v-model="form.toggle.batteryIndicator.lcd"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="LED">
        <ToggleSwitch
          v-model="form.toggle.batteryIndicator.led"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="電池残量警告">
      <SettingItem label="トーン">
        <ToggleSwitch
          v-model="form.toggle.batteryWarning.tone"
          :disable="!form.toggle.batteryIndicator.lcd && !form.toggle.batteryIndicator.led"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  name: 'BCOptionalFeaturesBattery', // 任意
  components: { ToggleSwitch, SettingGroup, SettingItem },

  data() {
    const radioSettings = useRadioSettingsStore()

    return {
      radioSettings,
      // ストアに仮保存済みの端末設定情報を取得する
      setting: radioSettings.getTempSetting(),

      form: {
        toggle: {
          batteryIndicator: {
            lcd: false,
            led: false,
          },
          batteryWarning: {
            tone: false,
          },
        },
      },
    }
  },

  watch: {
    // フォーム全体を監視（深い変更も拾う）
    form: {
      deep: true,
      handler() {
        this.transForm2Setting()
        // 最新の状態をストアへ反映
        this.radioSettings.saveTempSetting(this.setting)
      },
    },
  },

  methods: {
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.Battery

      // デバッグ用：ディープコピーでログ
      /* eslint-disable no-console */
      console.log('============================')
      console.log('before setting: ', JSON.parse(JSON.stringify(data)))

      data.BatteryIndicator.LCD = this.form.toggle.batteryIndicator.lcd
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.BatteryIndicator.LED = this.form.toggle.batteryIndicator.led
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.BatteryWarning.Tone = this.form.toggle.batteryWarning.tone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      console.log('after setting: ', JSON.parse(JSON.stringify(data)))
      /* eslint-enable no-console */
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.Battery

      /* eslint-disable no-console */
      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))
      /* eslint-enable no-console */

      this.form.toggle.batteryIndicator.lcd = data.BatteryIndicator.LCD === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.batteryIndicator.led = data.BatteryIndicator.LED === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.batteryWarning.tone = data.BatteryWarning.Tone === BC.COMMON.TOGGLE.ENABLE

      /* eslint-disable no-console */
      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
      /* eslint-enable no-console */
    },
  },

  beforeMount() {
    this.transSetting2Form()
  },
}
</script>
